import { Dialog } from "@themes/pollinator/ui/Dialog";
import type { DeletionInvitation } from "@core/features/invitation";
import {
  deletionTitle,
  deletionDescription,
} from "./invitationDeletionDialog.data";

export type Props = {
  onDone: () => void;
  onClose: () => void;
  isOpen: boolean;
  invitation: DeletionInvitation;
  programId: number;
};

export function InvitationDeletionDialog({
  onDone,
  onClose,
  isOpen,
  invitation,
}: Props) {
  const handleDelete = () => {
    // TODO: Implement delete mutation when backend API is ready
    // For now, just close the dialog
    onDone();
  };

  const inviteeName = invitation.first_name
    ? `${invitation.first_name} ${invitation.last_name || ""}`.trim()
    : invitation.email || "this invitation";

  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      title={deletionTitle}
      description={`${deletionDescription} Are you sure you want to delete the invitation for ${inviteeName}?`}
      isWithActions
      primaryButtonText="Delete"
      secondaryButtonText="Cancel"
      onPrimaryClick={handleDelete}
      onSecondaryClick={onClose}
      primaryButtonProps={{
        variant: "primary",
      }}
    />
  );
}

export default InvitationDeletionDialog;

